<template>
  <div>
  </div>
</template>

<script>
import { getSystemConfig } from '@/api/systemConfig.js'
export default {
  filters: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
    window.open(this.$route.params.url)
  },
  mounted() { 
  },
};
</script>
<style scoped lang="scss">
</style>